//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {AppMixin,} from "~/node_modules/sitis-nuxt/lib/mixins/index";
import Breadcrumbs from "~/components/page/PageBreadcrumbs";
import ArticleCard from "~/components/blog/ArticleCard.vue";
import ArticleReadMoreCard from "~/components/blog/ArticleReadMoreCard.vue";
import convertLocale from "~/helpers/convertLocale";
import languagesInfo from '~/constant/languiges-info.json';
import utilsGetOgUrl from "~/helpers/utilsGetOgUrl";
import MainImageBlob from "~/components/blog/MainImageBlob.vue";

export default {
  name: "artcle",

  head() {
    const newAlternateLink = this?.article?.['url_alternate'] || {};

    const newLinkArray = [];
    if (this.isMultiLanguages) {
      Object.keys(newAlternateLink).map((localeKey) => {
        const localeLink = newAlternateLink?.[localeKey] || "";
        newLinkArray.push({
          rel: 'alternate',
          href: localeLink,
          hreflang: convertLocale(localeKey),
          hid: localeKey === 'en' ? 'alternate-default-en' : `alternate-default-${localeKey}`
        })
      });
    }

    let meta = [
      {
        hid: "metadescription",
        name: "description",
        content: this?.article?.seo_description || "Articles",
      },
      {
        hid: "og:title",
        name: "og:title",
        property: "og:title",
        content: this?.article?.seo_title || "Articles",
      },
      {
        hid: "og:site_name",
        name: "og:site_name",
        property: "og:site_name",
        content: "GrizzlySMS",
      },
      {
        hid: "og:description",
        name: "og:description",
        property: "og:description",
        content: this?.article?.seo_description || "Articles",
      },
      {
        hid: "apple-mobile-web-app-title",
        name: "apple-mobile-web-app-title",
        content: `apple-${this?.article?.seo_title || "Articles"} `,
      },
      {
        hid: "og:image",
        name: "og:image",
        property: "og:image",
        content: this.getImgPath,
      },
      {
        hid: "og:url",
        name: "og:url",
        property: "og:url",
        content: this.getArticlePath,
      },
      {
        hid: "og:type",
        name: "og:type",
        property: "og:type",
        content: "article"
      },
    ];
    return {
      title: this?.article?.seo_title || this.appCfg?.siteName,
      meta,
      link: [...newLinkArray]
    };
  },

  mixins: [AppMixin],

  async asyncData(context) {
    const {$api, i18n, route, redirect, store, localePath, error} = context;
    let sameArticles = [];

    let slug = route.params.slug;

    // Получение статьи
    const article = await $api.agent.transport
      .get(`articles/${encodeURIComponent(slug)}?expand=tags,tagsServices`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return null;
      });
    store.commit('alternateLink/setLink', article?.['url_alternate'] || {});

    // Проверка на услугу если статья не найдена
    if (!article) {
      error({
        statusCode: 404,
        message: i18n.t('errorPage.pageNotFound')
      })

      return
    }
    if (article?.tags && article?.tags?.length) {
      const getStr = article?.tags.map(t => {
        return `filter[tag_id][]=${t.id}`
      }).join('&');

      sameArticles = await $api.agent.transport
        .get(`articles?${getStr}&filter[not][id]=${article.id}`)
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          return null;
        });

    }

    return {
      article,
      sameArticles
    };
  },

  computed: {
    getCurrentHost() {
      const isProd = !process.env.isDev;
      const currentLocale = this.$i18n.locale;
      return languagesInfo?.[currentLocale]?.domain;
    },
    getBreadcrunmbs() {
      let breadcrumbs = [
        {path: "/", title: this.$t("breadcrumbs.homePage")},
        {path: "/blog", title: this.$t("breadcrumbs.blog")},
        {path: this.$route.path, title: this?.article?.title || ""},
      ];
      return breadcrumbs;
    },

    getContent() {
      return this.article.content
        ? this.article.content
        : this.article.announce;
    },

    getArticlePath() {
      return utilsGetOgUrl({context: this})
    },

    getImgPath() {
      const imgId = String(this?.article?.image_id || "");
      if (!imgId) {
        return null
      }

      return this.$img(imgId);
    },
    getPublishDate() {
      //получаем сырое время преобразуем при помощи плагина
      const unixTime = this.article?.publish_from;
      return this.$formatDate(unixTime);
    },

    tagsServices: function () {
      return this.article?.tagsServices || [];
    },

    isMultiLanguages: function () {
      return process.env.isMultiLanguages
    }
  },

  components: {
    ArticleCard,
    Breadcrumbs,
    MainImageBlob,
    ArticleReadMoreCard,

    Comments: () => import("~/components/blog/Comments.vue"),
    TagsServices: () => import("~/components/blog/TagsServices.vue"),
  },

  mounted() {
    document.getElementById('scroll-container').scrollTo({top: 0});
  }
};
